import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class CashFlow {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.identity = data.identity || undefined;
        this.account = data.account || undefined;
        this.action = data.action || 0;
        this.bookingId = data.bookingId || undefined;
        this.ftCode = data.ftCode || undefined;
        this.note = data.note || undefined;
        this.name = data.name || undefined;
        this.onePayCode = data.onePayCode || undefined;
        this.orderCode = data.orderCode || undefined;
        this.orderDebit = data.orderDebit || 0;
        this.orderType = data.orderType || 0;
        this.paymentCredit = data.paymentCredit || 0;
        this.postDate = data.postDate ? moment.utc(data.postDate) : moment.utc().startOf('isoWeeks');
        this.productCode = data.productCode || undefined;
        this.property = data.property || undefined;
        this.rateCode = data.rateCode || undefined;
        this.refId = data.refId || undefined;
        this.pRefId = data.pRefId || undefined;
        this.status = data.status || undefined;
        this.ticketCode = data.ticketCode || undefined;
        this.ticketSerial = data.ticketSerial || undefined;
        this.transactionCode = data.transactionCode || undefined;
        this.transactionName = data.transactionName || undefined;
        this.refId = data.refId || undefined;
        this.userInfo = data.userInfo || undefined;
        this.redeemProperty = data.redeemProperty || undefined;
        this.checkCode = data.checkCode || undefined;
        this.setDetail(data.detail || {});
    }
    setDetail(data={}){
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            startDate: data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks'),
            endDate: data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days')
        }
    }
}

export class ReceiptsPayslip {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this.type = data.type || 1;
        this.transactionCode = data.transactionCode || undefined;
        this.account = data.account || undefined;
        this.orderCodes = data.orderCodes || [];
        this.note = data.note || undefined;
        this.totalAmount = data.totalAmount || undefined;
        this.ftCode = data.ftCode || undefined;
    }

    export() {
        return {
            type: this.type,
            transactionCode: this.transactionCode,
            account: this.account,
            orderCodes: this.orderCodes,
            note: this.note,
            totalAmount: parseInt(this.totalAmount),
            ftCode: this.ftCode
        };
    }
}

export class CashFlowTransaction {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.code = data.code || undefined;
        this.name = data.name || undefined;
    }
}

export class CashFlowAccount {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.code = data.code || undefined;
    }
}

export class CashFlowTransactionImbalance {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.orderCode = data.orderCode || undefined;
        this.amount = data.amount || undefined;
    }
}